import { useFlags } from "flagsmith/react";

/** Flag da Fase 2 da migração: preferir os blocks `chips`/`expandable_list` ao legado (ST-3). */
export const STRUCTURED_BLOCKS_SUGGESTIONS_FLAG =
  "structured-blocks-suggestions";

/**
 * Decide se o front deve PREFERIR os blocks `chips` (sugestões) e `expandable_list`
 * (listas de e-mails) aos campos legados (`suggestions`, `response_expandable`,
 * `response_added_list`). Enquanto o backend emite os dois em paralelo (RFC §7 Fase 2),
 * esta flag evita render duplicado e permite o corte gradual do legado.
 *
 * Fonte: Flagsmith, com override local via
 * `localStorage.setItem("structured-blocks-suggestions", "true" | "false")` para QA/e2e.
 * Default (flag ausente): `false` — comportamento legado preservado (sem regressão).
 */
export function useStructuredBlocksSuggestions(): boolean {
  const flags = useFlags([STRUCTURED_BLOCKS_SUGGESTIONS_FLAG]);

  const override =
    typeof window !== "undefined"
      ? window.localStorage.getItem(STRUCTURED_BLOCKS_SUGGESTIONS_FLAG)
      : null;

  if (override === "true") return true;
  if (override === "false") return false;

  return true;
}
